import { isMobile } from '~/utils';

const webOrMobile = (ismobile) => isMobile(ismobile) ? 'MOBILE' : 'WEB';

export const getHeaders = ({ globalData: { ismobile, locale } }) => ({
  'Content-Type': 'application/json',
  'X-HSBC-Channel-Id': webOrMobile(ismobile),
  'X-HSBC-Locale': locale,
  'X-HSBC-Chnl-CountryCode': 'MX',
  'X-HSBC-Chnl-Group-Member': 'HBMX',
});
